import React from "react";
import BondRetrievalBillingInformation from "./BondRetrievalBillingInformation";
import GoogleAutoComplete from "./ProbateGoogleAutoComplete";
import { LabeledCreatableSelect } from "./ProbateBondFormShared";

const ProbateBillingInformation = (props) => (
  <BondRetrievalBillingInformation
    bondType="probate"
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    {...props}
  />
);

export default ProbateBillingInformation;
